import React, { Component, Fragment } from 'react';
import _ from 'lodash';

import placeholderImg from './placeholder.png';
import placeholderImgYT from './placeholderYT.png';

class SiteScreenshot extends Component {
    renderImage = () => {
        const { url, isYT } = this.props;
        if (isYT && url) return (
            <div style={{ width: 260, height: 172, display: 'flex', alignItems: 'center', justifyContent: 'center' }} className="site-screenshot">
                <img style={{ display: 'block', borderRadius: 50 }} className="site-screenshot" width={100} alt="logo" src={url} />
            </div>)

        return <img width={260} height={172} alt="logo" className="site-screenshot" src={url || (isYT ? placeholderImgYT : placeholderImg)}/>
    }

    render() {
        const Wrap = ({ href, children }) => href ? <a href={href} target="_blank" rel="noopener noreferrer">{children}</a> : children;

       return <Wrap>
           {this.renderImage()}
       </Wrap>
    }
}

export default SiteScreenshot;
